









































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';

import authService from '@/services/auth-services';
import commonService from '@/services/common-services';

import Rating from '@/shared/components/Rating.vue';

@Component({
    components: {
        'rate': Rating
    }
})
export default class LeftMenu extends Vue {
    private activeMenu = '';

    get isGubuyDomain() {
        return window.location.hostname.toLowerCase() === 'app.gubuy.vn';
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    private async created() {
        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
        this.updateActiveMenu();
    }

    @Watch('$route', { immediate: true, deep: true })
    urlChange() {
        this.updateActiveMenu();
    }

    private updateActiveMenu() {
        const path = this.$route.path;
        if (
            path.indexOf('/ma-van-don') !== -1 ||
            path.indexOf('/transition') !== -1 ||
            path.indexOf('/phieu-xuat') !== -1 ||
            path.indexOf('/receipt') !== -1 ||
            path.indexOf('/khieu-nai') !== -1 ||
            path.indexOf('/complain') !== -1
        ) {
            this.activeMenu = 'operation';
        } else if (
            path.indexOf('/thanh-toan') !== -1
        ) {
            this.activeMenu = 'payment';
        } else if (
            path.indexOf('/ky-gui') !== -1 ||
            path.indexOf('/kien-tmdt') !== -1 ||
            path.indexOf('/bao-gia') !== -1 ||
            path.indexOf('/quotation') !== -1
        ) {
            this.activeMenu = 'deposit';
        } else if (
            path.indexOf('/product-search') !== -1 ||
            path.indexOf('/detail-product') !== -1 ||
            path.indexOf('/dashboard') !== -1 ||
            path.indexOf('/gio-hang') !== -1 ||
            path.indexOf('/cart') !== -1 ||
            path.indexOf('/don-hang') !== -1 ||
            path.indexOf('/order') !== -1
        ) {
            this.activeMenu = 'source';
        }
    }

    toggleMenu(key: string) {
        if (this.activeMenu == key) {
            this.activeMenu = '';
        } else {
            this.activeMenu = key;
        }
    }

    @Watch('userInfo', { immediate: true, deep: true })
    private async getCustomersInfo(newVal: any, oldVal: any) {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }
    
}
